import ContactUsService from '../../services/ContactUsService';
import contactUsUseCase from './contactUsUseCase';

const contactUsFactory = contactUsUseCase({
  ContactUsService: ContactUsService(),
});

export default contactUsFactory;
